module.exports = __webpack_public_path__ + "img/NPC3.png";